import {
  Required,
  IsString,
  IsNumber,
  DataValidator,
  transformKeys,
  IsArray,
  IsBoolean,
} from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

interface AssetsVoiceRequest {
  page: number;
  pageSize: number;
  userId?: string;
}

interface AssetsVoiceListResponse {
  page: number;
  page_size: number;
  templates: Array<{
    created_at: Date;
    description: string;
    id: string;
    input_text: string;
    is_starred: boolean;
    name: string;
    process_status: number;
    provider: string;
    sample_url: string;
    task_id: string;
    updated_at: Date;
    user_id: string;
    voice_tts_id: string;
  }>;
  total: number;
}

// AssetsVoice 嵌套类
export class AssetsVoice {
  @Required("Created at cannot be empty")
  @IsString("Created at must be a string")
  createdAt: string;

  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("IsStarred cannot be empty")
  @IsBoolean("IsStarred must be a boolean")
  isStarred: boolean;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("ProcessStatus cannot be empty")
  @IsNumber("ProcessStatus must be a number")
  processStatus: number;

  @Required("Provider cannot be empty")
  @IsString("Provider must be a string")
  provider: string;

  @Required("SampleUrl cannot be empty")
  @IsString("SampleUrl must be a string")
  sampleUrl: string;

  @Required("UserId cannot be empty")
  @IsString("UserId must be a string")
  userId: string;

  @Required("VoiceTtsId cannot be empty")
  @IsString("VoiceTtsId must be a string")
  voiceTtsId: string;
}

// Response 嵌套类
class AssetsVoiceListData {
  @IsArray("AssetsVoiceList must be an array")
  templates: AssetsVoice[] | null;

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateAssetsVoiceList = (
  response: AssetsVoiceListResponse
): AssetsVoiceListData => {
  const transformedData = transformKeys(response);

  try {
    const validatedData = DataValidator.validateOrThrow(transformedData, AssetsVoiceListData);
    if (!validatedData.templates) {
      return {
        ...validatedData,
        templates: [],
      };
    }
    return validatedData;
  } catch (error) {
    console.error("AssetsVoiceList list data validation failed:", error.message);
    throw error;
  }
};

/** 获取资产音频列表 */
export async function assetsVoiceList({ page, pageSize, userId }: AssetsVoiceRequest): Promise<AssetsVoiceListData> {
  const res = await apiV2.get<AssetsVoiceListResponse>("/users/myvoice", {
    page,
    page_size: pageSize,
    user_id: userId,
  });
  const data = transformAndValidateAssetsVoiceList(res.data);
  return data;
}
